import styled, { css } from "styled-components";
import { Button } from "@template/components/Button/styles.ts";

export const TabLabelsWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: stretch;

  ${Button} {
    &:first-of-type {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:last-of-type {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
`;
